import type { ReactElement } from 'react';
import { Route } from 'react-router-dom';

import type { NavItemConfig, RouteNavConfig } from '@revelio/auth';

import { RequireAuth } from './ProtectedRoute';

const flattenNavRouteItems = (items: RouteNavConfig[]): RouteNavConfig[] => {
  return items.reduce((acc, item) => {
    if (item.children && Array.isArray(item.children)) {
      return [
        ...acc,
        ...flattenNavRouteItems(item.children),
      ] as RouteNavConfig[];
    }
    return [...acc, item] as RouteNavConfig[];
  }, [] as RouteNavConfig[]);
};

export const reducedRoutes = (navItems: (RouteNavConfig | NavItemConfig)[]) =>
  flattenNavRouteItems(navItems).reduce<ReactElement[]>((routes, r, i) => {
    if (!r.element) {
      return routes;
    }
    const hasNestedRoutes = !!r.nestedRoutes?.length;
    routes.push(
      <Route
        key={i}
        path={r.path}
        element={
          <RequireAuth
            tab={r.serverTab}
            adminRequired={r.admin}
            clientAdminRequired={r.clientAdmin}
          >
            {r.element}
          </RequireAuth>
        }
      >
        {hasNestedRoutes &&
          r.nestedRoutes?.map((nr, j) => (
            <Route key={j} path={nr.path} element={nr.element} />
          ))}
      </Route>
    );
    return routes;
  }, []);
